import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

export default {
  heading: 'Grazie per la tua valutazione!',
  text: 'C\'è qualcosa che possiamo migliorare? Condividi la tua opinione con noi.',
  form: {
    fields: [
      {
        type: 'textarea',
        name: FEEDBACK_CONSTANTS.FEEDBACK_NAME,
        placeholder: 'La tua opinione...'
      }
    ],
    submit: {
      label: 'Invia'
    }
  }
};